<!-- если udnefined выбрать да -->
<template>
  <Radio
    class="radio"

    :values="[ $t( 'Yes' ), $t( 'No' ) ]"
    :value="( '' + value ) === 'true' ? $t( 'Yes' ) : $t( 'No' )"

    :disabled="disabled"

    @input="set"
    v-ok
  />
</template>

<script>
import Radio from "./Radio";

export default {
	name:  "DVfieldBoolean",
  components: {
    Radio
  },
	props: {
		label:    {
			type:    String,
			default: "",
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
		value:  {
			type:    [ Boolean, String ],
			default: false,
		}
	},
  data() {
		return {
		};
	},
  computed: {
  },
  methods: {
		set( event ) {
      this.$emit( 'input', event === this.$t( "Yes" ) );
		}
	}
};
</script>

<style scoped>
  .wrapper {
	  display: inline-block;
  }
</style>